<template>
  <div class="sitemap">
    <div v-if="$slots.sidebar" class="sitemap__sidebar">
      <slot name="sidebar" />
    </div>
    <section class="sitemap__content">
      <div v-if="hasTitle" class="sitemap__title">
        <slot name="title">
          {{ title }}
        </slot>
      </div>
      <div v-if="hasDesc" class="sitemap__desc">
        <slot>
          {{ desc }}
        </slot>
      </div>
      <ul :class="{ 'sitemap__map_padded': hasTitle || hasDesc }" class="sitemap__map">
        <li v-for="section in map" :key="section.code" class="sitemap__section">
          <router-link :to="section.to" class="sitemap__link">
            {{ section.text }}
          </router-link>
          <ul v-if="section.children && section.children.length > 0" class="sitemap__sub-map">
            <li v-for="subsection in section.children" :key="subsection.code" class="sitemap__sub-section">
              <router-link :to="subsection.to" class="sitemap__sub-link">
                {{ subsection.text }}
              </router-link>
            </li>
          </ul>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
    map: {
      type: Array,
      required: true,
    },
  },
  computed: {
    hasTitle() {
      return this.title || this.$slots.title;
    },
    hasDesc() {
      return this.desc || this.$slots.default;
    },
  },
};
</script>

<style lang="scss" scoped>
.sitemap {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;

  &__sidebar {
    width: 100%;
    padding-bottom: 20px;
  }

  &__sidebar,
  &__content {
    box-sizing: border-box;
  }

  &__title {
    font-size: 14px;
    line-height: 1.75em;
    padding: 10px 0;
  }

  &__desc {
    font-size: 12px;
    line-height: 1.5em;
    padding: 10px 0;
  }

  &__map {
    list-style-type: none;
    padding-top: 10px;
    display: grid;

    &_padded {
      padding-top: 30px;
    }
  }

  &__section {
    display: block;
    padding-bottom: 40px;
  }

  &__sub-section {
    display: block;
    position: relative;
    padding-left: 20px;
    margin-bottom: 6px;
  }

  @mixin link() {
    text-decoration: none;
    color: #4f4ca6;
  }

  &__link {
    @include link;

    text-decoration: none;
    font-size: 14px;
    line-height: 18px;
    font-weight: 700;
    text-transform: uppercase;
    display: block;
    margin-bottom: 6px;

    &:hover {
      color: #51acff;
      text-decoration: underline;
    }
  }

  &__sub-link {
    @include link;

    vertical-align: middle;
    font-size: 12px;
    line-height: 12px;
    font-weight: 400;
    text-indent: -18px;

    &::before {
      @include link;

      content: '—';
      display: block;
      position: absolute;
      line-height: 18px;
    }

    &:hover {
      color: #51acff;
      text-decoration: underline;

      &::before {
        color: #51acff;
        text-decoration: none;
      }
    }
  }
}

@media only screen and (min-width: 48em) {
  .sitemap {
    flex-wrap: nowrap;

    &__sidebar {
      width: 33%;
    }

    &__content {
      width: 67%;
    }

    &__sidebar + &__content {
      padding-left: 40px;
    }

    &__map {
      grid-template-columns: repeat(2, 1fr);
      column-gap: 20px;
    }

    &__section {
      display: inline-block;
    }
  }
}

@media only screen and (min-width: 64em) {
  .sitemap {
    flex-wrap: nowrap;

    &__sidebar {
      width: 25%;
    }

    &__content {
      width: 75%;
    }

    &__sidebar + &__content {
      padding-left: 40px;
    }

    &__map {
      grid-template-columns: repeat(3, 1fr);
      column-gap: 20px;
    }

    &__section {
      display: inline-block;
    }
  }
}

</style>



// WEBPACK FOOTER //
// SiteMap.vue?20542c6b